import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from './resources';
import { DEFAULT_LANGUAGE, DEFAULT_NAMESPACE, NAMESPACES } from './languages';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: DEFAULT_NAMESPACE,
    ns: NAMESPACES,
    supportedLngs: ['en', 'es', 'fr', 'de', 'fil'],
    nonExplicitSupportedLngs: true, // Matches 'es-ES', 'es-MX' -> 'es', 'fr-FR' -> 'fr', 'de-DE' -> 'de'
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        if (!lng) return DEFAULT_LANGUAGE;
        const normalized = lng.toLowerCase();
        // Map Tagalog codes to Filipino
        if (normalized.startsWith('tl') || normalized.startsWith('fil')) {
          return 'fil';
        }
        if (normalized.startsWith('es')) return 'es';
        if (normalized.startsWith('fr')) return 'fr';
        if (normalized.startsWith('de')) return 'de';
        if (normalized.startsWith('en')) return 'en';
        return lng;
      }
    }
  });

export default i18n;
